import Resource from './Resource';

export type ScimTokenState = {
	/** Derived from whether a SCIM key exists — there is no separate flag. */
	enabled: boolean;
	/** The base URL an admin pastes into their identity provider. */
	baseUrl: string;
	createdAt: string | null;
};

export type MintedScimToken = {
	/** The plaintext, returned by this call and never again. */
	key: string;
	baseUrl: string;
};

/**
 * The SCIM credential (WEB-8957). Not a CRUD resource: one credential per
 * account, addressed without an id, so the three operations are named rather
 * than inherited.
 */
class ScimToken extends Resource {
	constructor() {
		super('scimToken');
	}

	getState(): Promise<ScimTokenState> {
		return this._getRequest('', { methodName: 'getState' }).then(res => res.data.data);
	}

	mint(): Promise<MintedScimToken> {
		return this._postRequest('', {}, { methodName: 'mint' }).then(res => res.data.data);
	}

	revoke(): Promise<void> {
		return this._deleteRequest('', { methodName: 'revoke' }).then(() => undefined);
	}
}

export default new ScimToken();
